import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async saveReceita({ commit }, data) {
      try {
        return await api.post(
          `/centros-custos/${data.codCCustoPai}/orcamento/${data.orcamentoId}/receitas`,
          data.receita,
        )
      } catch (error) {
        throw error
      }
    },

    async getReceitas({ commit }, filters) {
      try {
        const response = await api.get(
          `/centros-custos/${filters.codCCustoPai}/orcamento/${filters.orcamentoId}/receitas`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getReceita({ commit }, filters) {
      try {
        const response = await api.get(
          `/centros-custos/${filters.codCCustoPai}/orcamento/${filters.orcamentoId}/receitas/${filters.receitaId}`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async updateReceita({ commit }, data) {
      try {
        return await api.put(
          `/centros-custos/${data.codCCustoPai}/orcamento/${data.orcamentoId}/receitas/${data.receitaId}`,
          data.receita,
        )
      } catch (error) {
        throw error
      }
    },

    async deleteReceita({ commit }, data) {
      try {
        return await api.delete(
          `/centros-custos/${data.codCCustoPai}/orcamento/${data.orcamentoId}/receitas/${data.receitaId}`,
        )
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
